<template>
  <v-data-table
    dense
    :headers="this.headers"
    :options.sync="pagination"
    :footer-props="footerProps"
    :server-items-length="this.list.count"
    :items="this.list.items"
    :loading="$apollo.queries.list.loading"
    item-key="_id"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item.propertyIdentificationCode }}</td>
        <td>{{ item.lpaUserId }}</td>
        <td>{{ item.memberNumber }}</td>
        <td>{{ item.syncRowVersion }}</td>
        <td>{{ item.lastSyncAt | formatDateTime }}</td>
        <td>{{ item.syncProblemDetails }}</td>
        <td class="text-end">
          <v-btn
            small
            icon
            @click="$emit('open', item)"
            :disabled="!item.registrationId"
          >
            <v-icon color="info">search</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'ProducerList',

  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    headers: [
      {
        text: 'PIC',
        value: 'propertyIdentificationCode',
        sortable: false
      },
      {
        text: 'LPA User ID',
        value: 'lpaUserId',
        sortable: false
      },
      {
        text: 'Member Number',
        value: 'memberNumber',
        sortable: false
      },
      {
        text: 'Sync Version',
        value: 'syncRowVersion',
        sortable: false
      },
      {
        text: 'Last Sync',
        value: 'lastSyncAt',
        sortable: false
      },
      {
        text: 'Problem details',
        value: 'syncProblemDetails',
        sortable: false
      },
      {
        text: 'Actions',
        value: 'actions',
        class: 'text-end',
        sortable: false
      }
    ],
    pagination: {
      sortDesc: [false],
      page: 1,
      itemsPerPage: 50
    },
    footerProps: {
      'items-per-page-options': [10, 25, 50, 100, 200, 500]
    },
    list: {
      count: 0,
      items: []
    }
  }),

  apollo: {
    list: {
      query: gql`query ListProducers ($filters: FilterFindManyProducerInput, $page: Int!, $perPage: Int!) {
        list: producerManyPagination(filter: $filters, page: $page, perPage: $perPage, sort: _ID_DESC) {
          count
          items {
            _id
            memberNumber
            propertyIdentificationCode
            lpaUserId
            registrationId
            syncRowVersion
            lastSyncAt
            syncProblemDetails
          }
        }
      }`,
      variables () {
        return {
          filters: this.filters,
          page: this.pagination.page,
          perPage: this.pagination.itemsPerPage
        }
      },
      debounce: 250,
      error (e) {
        this.onError(e)
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    }
  }
}
</script>
